<div class="readiness-page">
  <div class="readiness-container">
    <!-- Header -->
    <header class="readiness-header">
      <div>
        <p class="eyebrow">Placement Intelligence</p>
        <h1 class="page-title">Placement Readiness</h1>
        <p class="page-desc">
          Understand how ready the student cohort is and identify where intervention is needed.
        </p>
      </div>
      <span class="cohort-filter-badge">
        {{ academicYear }} · {{ department }}
      </span>
    </header>

    <!-- Main Content Flow -->
    <div class="sections-stack">
      <!-- 1. KPI Row -->
      <app-kpi-row [kpis]="kpis"></app-kpi-row>

      <!-- 2. Cohort Overview -->
      <section class="section-block">
        <div class="section-title-wrap">
          <h2 class="block-title">Cohort Overview</h2>
          <p class="block-desc">Readiness distribution across the assessed cohort</p>
        </div>
        <app-cohort-donut [kpis]="{ assessed: kpis.assessed, averageScore: kpis.averageScore }" [cohort]="cohort"></app-cohort-donut>
      </section>

      <!-- 3. Readiness Framework (6 Dimensions) -->
      <section class="section-block">
        <div class="section-title-wrap">
          <h2 class="block-title">Readiness Framework</h2>
          <p class="block-desc">Six dimensions used to understand placement readiness.</p>
        </div>
        <app-dimension-grid></app-dimension-grid>
      </section>

      <!-- 4. AI Student Intelligence Insights -->
      <app-ai-insights [insightGroups]="insightGroups"></app-ai-insights>
    </div>
  </div>
</div>
